import React from "react";

const Resources = () => {
  return <div></div>;
};

export default Resources;
